export default __webpack_public_path__ + "static/media/times.92d67fd3.svg";